// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"266":"736c60c8","879":"fb278f33"}[chunkId] + ".chunk.js";
};